<template>
<div>
  <div v-if='withToolbar' >
    <v-btn
      @click.native='activeComponent="Reschedule"'
      icon class='indigo--text' ><v-icon>today</v-icon></v-btn>
    <v-btn
      @click.native='activeComponent="InvoiceDetails"'
      icon class='indigo--text' ><v-icon>account_balance_wallet</v-icon></v-btn>
    <v-btn
      @click.native='activeComponent="Notes"'
      icon class='indigo--text' ><v-icon>note</v-icon></v-btn>
  </div>

  <!-- <transition name='fade' > -->

  <component
    :is="activeComponent"
    :stand-alone="standAlone"
    :with-time-selector='withTimeSelector'
    :with-back='false'
    :appointment='appointment'
    :value='appointment'
    :touch='touch'
    @note:save='$emit("close")'
    @appointmentcancelled='$emit("close")'
    @appointmentrescheduled='$emit("close")'
    @close='$emit("close")' >
  <!-- inactive components will be cached! -->
  </component>

  <!-- </transition> -->

</div>
</template>
<script type="text/javascript">

// appointments
import Reschedule from '@/components/appointment/edit/Reschedule'
import InvoiceDetails from '@/components/appointment/edit/InvoiceDetails'
// import CodePicker from '@/components/pickers/CodePicker'
import Notes from '@/components/appointment/edit/Notes'
import Cancel from '@/components/appointment/edit/Cancel'
import Delete from '@/components/appointment/edit/Delete'
import QuickCreate from '@/components/appointment/Create'
// import QuickInvoice from '@/components/appointment/QuickInvoice'
// invoice
// import InvoiceCodes from '@/components/invoice/InvoiceCodes'
// clients:
import CreateClient from '@/components/client/Create'

export default {
  name: 'GlobalDialogContainer',
  props: {
    appointment: { type: Object, default: () => { return {} } },
    initial: { type: String, default: 'Reschedule' },
    withToolbar: { type: Boolean, default: true }
  },
  components: {
    Reschedule,
    InvoiceDetails,
    Notes,
    Cancel,
    Delete,
    QuickCreate,
    // QuickInvoice,
    CreateClient
  },
  watch: {
    initial () {
      this.activeComponent = this.initial
    },
    activeComponent () {
      if (this.activeComponent !== 'QuickCreate') {
        this.touch++
      }
    }
  },
  data () {
    return {
      activeComponent: this.initial,
      touch: 1
    }
  },
  computed: {
    standAlone () {
      return this.activeComponent === 'Reschedule'
    },
    withTimeSelector () {
      return this.activeComponent === 'QuickCreate'
    }
  }
}
</script>



// WEBPACK FOOTER //
// GlobalDialogContainer.vue?435c824f